<template>
  <div id="mijnTarieven" class="uk-width-1-2@m tone-of-voice-main"
  >
    <div class="uk-padding-larger">
      <h4 class="
              uk-text-secondary-muted
              uk-text-uppercase
              uk-text-lighter
              uk-text-medium
              text-spacing-medium uk-margin-small-bottom
              tone-of-voice-title-text"
          v-if="subTitle.length > 0"
      >
        {{subTitle}}
      </h4>
      <h3 class="uk-margin-remove-top text-spacing-large
            uk-heading-small uk-text-lighter uk-text-uppercase uk-text-condensed
            tone-of-voice-header-text"
          :class="{'uk-text-secondary': !primary }"
      v-html="title"></h3>
      <p class="tone-of-voice-text" :class="{'uk-text-secondary': !primary }">
        <slot/>
      </p>
      <div class="uk-flex uk-margin-medium-top button-flex">
      <div class="voice-over-button uk-display-block small-button-orange uk-margin-small-right">
        <router-link :to="{ path: '/', hash: '#contactFormThree' }" class="
        voice-over-button-clickable-section uk-display-block small-button-orange">
          <a class="voice-over-button-text small-button-orange-text text-transform-none">
            Neem contact op
          </a>
        </router-link>
      </div>
      <div class="voice-over-button uk-display-block small-button-brown bottom-button">
        <a href="tel:31641744233" class="voice-over-button-clickable-section
            uk-display-block small-button-brown small-button-brown-border">
          <a class="voice-over-button-text small-button-brown-text text-transform-none
          mijn-tarieven-brown-button">
            Bel mij direct
          </a>
        </a>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'ImageSectionToneOfVoice',
  props: {
    primary: {
      type: Boolean,
      default: false,
    },
    title: String,
    subTitle: {
      type: String,
      required: String,
    },
    buttonText: {
      required: false,
      type: String,
    },
    buttonLink: {
      required: false,
      type: String,
    },
  },
  computed: {
    buttonLinkParsed() {
      return this.buttonLink ?? '';
    },
  },
});
</script>
